import { IconType } from '@outdoria/ui';

export const EntityIcon: Record<string, IconType> = {
  ITEMS: 'Armory',
  MATERIALS: 'ItemBox',
  HABITATS: 'Tree',
  MONSTERS: 'Monster',
  RESOURCES: 'Star',
  QUESTS: 'Quest',
  USERS: 'Friends',
};
